import { BehaviorSubject } from 'rxjs';
import { takeUntil, tap, filter } from 'rxjs/operators';
import { debugToConsole } from '../dev/debug-operator'
import * as _ from 'lodash';

import {
  PageBaseComponent,
  Settings,
  SettingsService,
  LocalStoreManager

} from './page-base.component';

//exports
export * from './page-base.component';
export * from '../../shared/animations/animations';

export enum SortDirection {
  asc = 'asc',
  desc = 'desc'
}

//export function CustomInjectable(annotation: any) {
//  return function (target: Function) {
//    var parentTarget = Object.getPrototypeOf(target.prototype).constructor;
//    var parentAnnotations = Reflect.getMetadata('design:paramtypes', parentTarget);

//    Reflect.defineMetadata('design:paramtypes', parentAnnotations, target);
//  }
//}
//// https://stackoverflow.com/questions/37117698/angular2-use-imported-libs-from-base-class
//@CustomInjectable()
export class ItemsBaseComponent<TItem> extends PageBaseComponent {

  protected sortedBy: string = '';
  public sortedDirection = SortDirection.asc;//public to be used in template
  public sortBy$ = new BehaviorSubject<string>(this.sortedBy);//public to be used in template
  
  public items: TItem[] = [];
  //protected observableItems = new BehaviorSubject<any[]>([]);

  constructor(
    settingsService?: SettingsService,
    localStorage?: LocalStoreManager
  ) {
    super(settingsService, localStorage);

    this.sortBy$
      .pipe(
        debugToConsole("start pipe: ItemsBaseComponent: sortBy$"),
        filter((prop, index) => prop != '' && this.items.length > 0),
        tap(prop => {
      
          if (this.sortedBy.toLowerCase() === prop.toLowerCase()) {
            this.sortedDirection = (this.sortedDirection === SortDirection.asc) ? SortDirection.desc : SortDirection.asc;
          }
          this.sortedBy = prop;

          this.items = this.orderBy(this.items, prop, this.sortedDirection);
        }),
        takeUntil(this.ngUnsubscribe),
      )
      .subscribe();
  }

  protected orderBy(items: any[], prop: string, direction: string): any[] {
    //var test = _.orderBy(this.items, ['type', 'name'], ['asc', 'desc']);
    //return _.orderBy(items, [prop], [direction]);
    return _.orderBy(items, [prop], (direction ===  SortDirection.asc ? "asc" : "desc"));
  }
}
